export const ROUTES = {
  MAIN_ROUTE: '/',
};
